import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showError} from 'actions/CommonActions';
import { formError, formInput,clearFormInput } from 'actions/FormActions';
import { convertBulkToUnit } from 'actions/EntityActions';
import LOOKUP from 'constants/lookup';
import DialogInput from 'screens/components/advanced/DialogInput';
import Button from 'screens/components/basic/Button';
import TextInput from 'screens/components/basic/TextInput';
import SelectInput from 'screens/components/basic/SelectInput';
import { mapWarehouseListTransfer } from 'utils/mappers';
import GenericTable from 'screens/components/advanced/GenericTable';

const dialogStyle = {
    width: '70%',
    maxWidth: 'none'
};

class BulkToUnitDialog extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            open: false,
            warehouses: null
        };
    }

    componentWillReceiveProps(newProps) {
        if (this.props.product !== newProps.product) {
            if (newProps.product) {
                this.setState({ open: true, warehouses: newProps.product.warehouses.filter(item => item.warehouseType !== 3) });
            }
            else {
                this.onClose();
            }
        }
    }

    componentWillUnmount(){
        this.props.clearFormInput(`warehouseBultToUnitTableSelectedRows`);
        this.props.clearFormInput(`${this.props.name}NumOfPacks`);
        this.props.clearFormInput(`${this.props.name}Weight`);
        this.props.clearFormInput(`${this.props.name}Price`);
    }


    confirmBulkToUnit = (maxQuantity) => {
        let p = this.props;
        //Getting the warehouse selected row
        let selectedWarehouse = null;
        if(this.props.selectedRows !== null && this.props.selectedRows !== undefined) {
            selectedWarehouse = this.state.warehouses[this.props.selectedRows[0]];
        }else{
            this.props.showError("Please select the warehouse you want to ADJUST");
            return;            
        }
        
        let model = {
            weight: this.props.Weight,
            productId: this.props.product.productId,
            price: this.props.price,
            packageReference: selectedWarehouse ? selectedWarehouse.packageReference : '',
            warehouseId: selectedWarehouse ? selectedWarehouse.warehouseId : null,
            branchId: this.props.branchId,
            numOfPackages: this.props.NumOfPacks
        };
        
        this.props.convertBulkToUnit(model);
         
    }

    onClose = () => {
        this.props.onClose();
        this.props.formInput(this.props.name + 'NumOfPacks', null);
        this.props.formError(this.props.name + 'NumOfPacks', null);
        this.props.formInput(this.props.name + 'Weight', null);
        this.props.formError(this.props.name + 'Weight', null);
        this.props.formInput(this.props.name + 'Price', null);
        this.props.formError(this.props.name + 'Price', null);
        this.setState({ open: false });
    }

    render() {
        const p = this.props;
        const s = this.state;

        const actions = [
            <Button
                key={1}
                type="CancelButton"
                className="btn-space"
                label={LOOKUP.common.cancel.text}
                secondary={true}
                onTouchTap={() => this.onClose()}
            />,
            <Button
                key={2}
                className="pull-right btn-space"
                type="RaisedButton"
                label={"Confirm"}
                onTouchTap={() => this.confirmBulkToUnit(row !== null && row !== undefined ? warehouses[row[0]].quantity : 0)}
            />
        ];

        let product = p.product;
        let warehouses = [];
        if(this.state.warehouses !== null && this.state.warehouses !== undefined) {
            warehouses = this.state.warehouses;
        }

        let row = this.props.selectedRows;

        return (
            <div>
                <DialogInput
                    title={`Bulk To Unit Conversion`}
                    actions={actions}
                    modal={true}
                    className="adjust_Product"
                    open={s.open}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}>
                    <div className="adjustProducts">
                        <div>
                            <div className="form-group">

                                <div className="row m-0 product-info-modal-transfer">
                                    <div className="col-lg-12">                                        
                                        <h4>{product ?`Product Name: ${product.productName} `: ''}</h4>
                                        <p>
                                            {product ? `SKU: ${product.productSKU}` : ''}<br />
                                            {product ? `Type: ${product.productType}` : ''}<br />
                                            {product ? `Category: ${product.productCategory}` : ''}
                                        </p>
                                    </div>
                                </div>

                                <div className="row m-0">
                                    <div className="col-lg-12">
                                        <h4>Select the Warehouse</h4>
                                        <GenericTable
                                            className="table-inventory"
                                            compName="warehouseBultToUnitTable"
                                            tableHeaderClassName="table-products-header"
                                            tableBodyClassName="table-products"
                                            adjustForCheckbox={true}
                                            displaySelectAll={false}
                                            displayRowCheckbox={true}
                                            enableSelectAll={false}
                                            multiSelectable={false}
                                            selectable={true}
                                            stripedRows={true}
                                            columns={LOOKUP.transferProduct.tableColumnsWarehouseTransfer}
                                            rows={mapWarehouseListTransfer(warehouses)} 
                                        />
                                    </div>
                                </div>

                                    <div className="row m-0">
                                    <div className="col-lg-12">
                                        {
                                            row !== null && row !== undefined && row.length > 0 &&(
                                            <div>
                                                <TextInput name={`${this.props.name}NumOfPacks`}
                                                    hintText={"Select Number Of Units"}
                                                    type="number"
                                                    fullWidth={true}
                                                    label="Amount"
                                                    floatingLabelText="Number Of Units"
                                                />
                                            </div>
                                            )
                                        }
                                    </div>
                                    </div>

                                {
                                    row !== null && row !== undefined && row.length > 0 &&
                                    (
                                        <div className="row m-0">
                                            <div className="col-lg-12">
                                            <SelectInput
                                                name={`${this.props.name}Weight`}
                                                fullWidth={true}
                                                label={`Weight Per Unit`}
                                                floatingLabelText={`Weight Per Unit`}
                                                options={LOOKUP.transferProduct.BulkToUnitWeightOptions}
                                                hintText={`weight per unit`} />
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    row !== null && row !== undefined && row.length > 0 &&
                                    (
                                        <div className="row m-0">
                                            <div className="col-lg-12">
                                                <TextInput name={`${this.props.name}Price`}
                                                        hintText={"Price Per Unit (Optional)"}
                                                        type="number"
                                                        fullWidth={true}
                                                        label="Price Per Unit (Optional)"
                                                        floatingLabelText="Price Per Unit (Optional)"
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        product: state.entity.productForAdjustment,
        selectedRows: state.form["warehouseBultToUnitTableSelectedRows"],
        NumOfPacks: state.form[`${ownProps.name}NumOfPacks`] ? parseFloat(state.form[`${ownProps.name}NumOfPacks`]) : null,
        Weight: state.form[`${ownProps.name}Weight`] ? state.form[`${ownProps.name}Weight`] : null,
        price: state.form[`${ownProps.name}Price`] ? state.form[`${ownProps.name}Price`] : null
    };
}

function mapDispatchToProps(dispatch) {
    return {
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formError: (name, error) => dispatch(formError(name, error)),
        formInput: (name, value) => dispatch(formInput(value, name)),
        showError: (message) => dispatch(showError(message)),
        convertBulkToUnit: (model) => dispatch(convertBulkToUnit(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkToUnitDialog);